import { render, staticRenderFns } from "./productPage.vue?vue&type=template&id=39ca64f8&"
import script from "./productPage.vue.ts?vue&type=script&lang=ts&"
export * from "./productPage.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports